import * as types from '../../action-types';
import { savePSAInformation as initialState } from "../../initialState";

const savePSAInformation = (state=initialState, action) => {
  switch (action.type) {
    case types.SAVE_PSA_INFORMATION_START:
      return {
        ...state,
        isLoading: true
      };
    case types.SAVE_PSA_INFORMATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.SAVE_PSA_INFORMATION_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.SAVE_PSA_INFORMATION_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default savePSAInformation;
